import type { ItemResponse } from "@finn-no/mobility-dealer-types";

export type {
  Ad,
  DealerBrandingPageResponse,
  GalleryImage,
  ItemResponse,
  LatestAdsBySearchKey,
  OrganisationResponse,
  OtherLocation,
  OtherLocationOpeningHoursInfoStateEnum,
} from "@finn-no/mobility-dealer-types";

export enum DealerItemStatus {
  Ok = "ok",
  NotFound = "notFound",
  NotDealerAd = "notDealerAd",
}

export type ErrorStatus = Exclude<DealerItemStatus, DealerItemStatus.Ok>;

export type DealerItemResult = { status: DealerItemStatus.Ok; data: ItemResponse } | { status: ErrorStatus };
